import PostItem from "components/molecules/PostItem";
export default function RelatedPosts({ data }) {
  return (
    <div className="mb-10 hidden text-bbc-brand-800 lg:mb-0 lg:block">
      <div className=" text-2xl font-semibold leading-9 ">Related Posts</div>

      <div className="row mt-6 gap-y-6 lg:mt-8">
        {data.map((item, index) => (
          <div className="col-12" key={index}>
            <PostItem post={item} layout="horizontal" />
          </div>
        ))}
      </div>
    </div>
  );
}
